import { createTheme } from "@mui/material/styles";

export const enrxTheme = createTheme({
  palette: {
    primary: {
      main: "#37a46e",
    },
    secondary: {
      main: "#3f97b5",
    },
  },
});
